import { DoneIcon } from "outline-icons";
import { createLazyComponent } from "~/components/LazyLoad";
import { Hook, PluginManager } from "~/utils/PluginManager";
import config from "../plugin.json";

PluginManager.add([
  {
    ...config,
    type: Hook.Settings,
    value: {
      group: "Workspace",
      after: "Audit Log",
      icon: DoneIcon,
      component: createLazyComponent(() => import("./License")),
    },
  },
]);
